import { formatRupiah } from "@/helpers/utils";
import ApiService from '@/services/api';
import Swal from "sweetalert2";
import { _ } from "gridjs-react";
import dayjs from "dayjs";

const getStatusSchedule = (status) => {
  const badges = {
    paid: 'bg-green-100 text-green-800 border-green-300',
    cancelled: 'bg-red-100 text-red-800 border-red-300',
    pending: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

const getStatusBadgeLoan = (status) => {
  const badges = {
    process: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    approved: 'bg-green-100 text-green-800 border-green-300',
    rejected: 'bg-red-100 text-red-800 border-red-300',
    submitted: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

export const columnsLoan = (id,navigate) => [
    {
        name: 'Nama Produk Pinjaman',
        data: (row) => row?.loan_product?.name,
    },
    {
        name: 'Sisa Hutang',
        data: (row) => formatRupiah(row?.outstanding_balance),
    },
    {
        name: 'Status',
        data: (row) => row.status,
        formatter: (cell) => {
            return _(<span className={`text-gray-900 px-3 py-1 text-center text-sm font-semibold rounded-md border ${getStatusBadgeLoan(cell)}`}>{cell}</span>);
        }
    },
    {
        name: 'Info',
        data: (row) => row,
        formatter: (cell) => {
            const handleClick = (() => {
                navigate(`/admin/loans-payment?loansId=${cell.id}&id=${id}`)
            })
            return _(
                <div>
                    <button
                        className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
                        onClick={() => handleClick()}
                    >
                        <i className='mgc_check_line'></i>
                    </button>
                </div>
            )
        }
    }
]

export const tableColumnsMember = [
  { title: 'Member', queryKey: 'full_name' },
  { 
    title: 'Registration Date', 
    queryKey: 'join_date',
    component: (item) => (
      <span>
        {item.join_date ? new Date(item.join_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { title: 'Contact', queryKey: 'phone_number' },
  { title: 'Status', queryKey: 'status' },
];

export const scheduleColumns = [
  {
    name: 'Keterangan',
    data: (row) => row.installment_number,
    formatter: (cell) => {
        return _(<span>Angsuran { cell }</span>);
    }
  },
  {
    name: 'Jatuh Tempo',
    data: (row) => row.due_date,
    formatter: (cell) => {
      return _(
        <span>
          {dayjs(cell).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Pokok',
    data: (row) => formatRupiah(row.principal_amount),
  },
  {
    name: 'Bunga',
    data: (row) => formatRupiah(row.interest_amount),
  },
  {
    name: 'Denda',
    data: (row) => formatRupiah(0),
  },
  {
    name: 'Tagihan',
    data: (row) => formatRupiah(row.total_installment),
  },
  {
    name: 'Status',
    data: (row) => row.status,
    formatter: (cell) => {
      return _(<span className={`text-gray-900 w-100 text-center px-3 py-1 text-sm font-semibold rounded-md border ${getStatusSchedule(cell)}`}>{cell === 'paid' ? 'Lunas' : 'Belum Lunas'}</span>);
    }
  },
]

export const renderActionMember = (row, onClose, navigate) => {
  const handleClick = () => {
    navigate(`/admin/loans-payment?id=${row.id}`);
    onClose();
  };
  return (
    <button
      className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
      onClick={handleClick}
    >
      <i className='mgc_check_line'></i>
    </button>
  )
}